import React from 'react';
import PropTypes from 'prop-types';

const TextAreaElement = ({
  question,
  placeholder,
  id,
  setAnswers,
  answer
}) => {
  // TODO figure out why event.persist() is needed and why it works
  const handleChange = (event) => {
    event.persist();
    setAnswers(previousAnswers => ({
      ...previousAnswers, [id]: event.target.value
    }));
  };

  return (
    <div className="text-area-element">
      <div className="item-wrapper">
        <div className="item-question">{question}</div>
        <div className="item-answer">
          <textarea
            id={id}
            value={answer}
            onChange={handleChange}
            placeholder={placeholder}
            rows={4}
          />
        </div>
      </div>
    </div>
  );
};

TextAreaElement.propTypes = {
  question: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  setAnswers: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  answer: PropTypes.string
};

TextAreaElement.defaultProps = {
  placeholder: '',
  answer: ''
};

export default TextAreaElement;
